import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { requestFailedMatcher } from '../request-failed/reducer';
import {
  type IMarketingPreferenceState,
  type IMarketingPreferenceUpdate,
  type IMarketingPreferenceUpdateResponse,
} from './types';

const initialState: IMarketingPreferenceState = {
  token: null,
  consent: null,
  isUpdating: false,
  updateError: false,
  justUpdated: false,
  reason: null,
};

const marketingPreferenceSlice = createSlice({
  name: 'MarketingPreference',
  initialState,
  reducers: {
    marketingPreferenceUpdate: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: IMarketingPreferenceUpdate,
    ): void => {
      state.isUpdating = true;
      state.updateError = false;
      state.justUpdated = false;
      state.reason = null;
    },
    marketingPreferenceUpdateResponse: (
      state,
      action: PayloadAction<IMarketingPreferenceUpdateResponse['payload']>,
    ): void => {
      state.isUpdating = false;

      if (action.payload.ok && action.payload.consent !== undefined) {
        state.consent = action.payload.consent;
        state.justUpdated = true;
      } else {
        state.updateError = true;
        state.reason = action.payload.reason ?? null;
      }
    },
  },
  extraReducers: (builder): void => {
    builder.addMatcher(
      requestFailedMatcher('MarketingPreference'),
      (state): void => {
        state.isUpdating = false;
        state.updateError = true;
      },
    );
  },
});

export const { marketingPreferenceUpdate, marketingPreferenceUpdateResponse } =
  marketingPreferenceSlice.actions;

export default marketingPreferenceSlice.reducer;
